import createReducer from '../reducer/createReducer';
import { createStore } from 'redux';

const store = createStore(
    createReducer(),
    {}
);

export default store;